export default __webpack_public_path__ + "static/media/arrow-back.bd67b680.svg";